import CheckBoxRoot from "features/shared/components/checkbox/styles/CheckBoxRoot.styled";
import CheckboxLabel from "features/shared/components/checkbox/styles/CheckboxLabel.styled";
import StyledCheckbox from "features/shared/components/checkbox/styles/StyledCheckbox.styled";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import styled from "styled-components";

const HaveDocumentQuestion = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.base3};

  .subtitle {
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.base4};
  }

  position: relative;

  ${CheckBoxRoot} ${StyledCheckbox} {
    margin-right: 0;
    border-radius: 100%;
    border: 1px solid ${({ theme }) => theme.colors.base3};

    width: 28px;
    height: 28px;
    margin-right: 0;
    box-sizing: border-box;
  }

  input[type="checkbox"]:checked + ${StyledCheckbox} {
    background-color: ${({ theme }) => theme.colors.primary1};
    border-color: ${({ theme }) => theme.colors.primary1};
  }

  ${CheckBoxRoot} ${StyledCheckbox} img {
    display: none;
  }

  ${CheckboxLabel} {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 50%;
    padding: 16px;

    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  ${ButtonTitle} {
    margin-top: 16px;
  }
`;

export default HaveDocumentQuestion;
